import React from "react";
import { List } from "antd";
import { ListItem, ItemProps } from "./list-item";

import styles from "./pricing-totals.css";
const { ["totals"]: totalsClassName, ["totals-header"]: totalsHeaderClassName } = styles as any;

export const PricingTotals: React.FC<{ data: ItemProps[] }> = ({ data }) => {
  return (
    <List
      header={<div className={totalsHeaderClassName}>Pricing Summary </div>}
      bordered={true}
      className={totalsClassName}
      size={"small"}
    >
      {data.map((item, index) => (
        <ListItem {...item} key={`${index}`} />
      ))}
    </List>
  );
};
